import { docUrl } from '@/config'
import { addSign } from '@/utils/request'

export function setStorage(key, data) {
  localStorage[key] = JSON.stringify({
    data,
    time: new Date().getTime()
  })
}
export function getStorage(key, exp) {
  exp = exp || 60 * 60 * 1000; // 一小时
  const data = localStorage[key]
  if (!data) {
    localStorage.removeItem(key)
    return false
  }
  const dataObj = JSON.parse(data)
  if (exp && new Date().getTime() - dataObj.time > exp) {
    return false
  }
  return dataObj.data
}

export function isLogin() {
  return getStorage('login_token') && getStorage('user_id')
}

export function goDoc() {
  const qStr = Object.entries(addSign({ channel: 'pingan_com' })).map(([key, val]) => `${key}=${val}`).join('&')
  window.location.href = `${docUrl}?${qStr}`
}
